import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import { Block } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphCTA as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphCTAProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphCTA: React.FC<ParagraphCTAProps> = ({
  entity,
}) => {
  const paragraphEntity = entity.toJS();
  const blockEntity = paragraphEntity.field_cta_block[0].entity;

  return (
    <div className="Paragraph ParagraphCTA">
      <Block entity={Immutable.fromJS(blockEntity)} />
    </div>
  );
};

export default ParagraphCTA;
